import FuturePetSpeciesData from '../airtable/FuturePetSpecies';

const AllSpeciesData = [...FuturePetSpeciesData];

export const species = AllSpeciesData.sort(
  (a, b) => a.encyclopedia_order - b.encyclopedia_order,
).map((x) => x.id);

export type AllSpecies = typeof AllSpeciesData[number]['id'];
